<template>
  <div class="container">
    <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
    >
      <div class="sectionTitle">客户基础详情</div>
      <van-collapse v-model="activeNames" :border="false">
        <van-collapse-item title="客户中会员与非会员的占比" name="percent" class="m-b-16">
          <div class="collapseContent" style="margin-top: 11px">
            <div class="rowFlex alignitems jus-btw m-b-24">
              <div class="columnFlex">
                <div class="itemTitle m-b-8">客户总数(人):</div>
                <div class="numberInfo">{{getTransformData(dataInfo.khzs)}}</div>
              </div>
              <div class="columnFlex alignitems-end">
                <div class="itemTitle m-b-8">客户内会员比例:</div>
                <div class="numberInfo">{{formatFloatMult(formateNumber(getTransformData(dataInfo.qnhybl)))}}%</div>
              </div>
            </div>
            <div class="barView">
              <div class="columnFlex m-b-16">
                <div class="rowFlex alignitems m-b-16">
                  <div v-if="Number(100-formatFloatMult(formateNumber(dataInfo.qnhybl))) > 0" class="progress" :style="{width:`${Number(100-formatFloatMult(formateNumber(dataInfo.qnhybl)))}%`}"></div>
                  <div class="countInfo">{{dataInfo.fhys}}</div>
                </div>
                <div class="itemSubTitle">非会员数</div>
              </div>
              <div class="columnFlex">
                <div class="rowFlex alignitems m-b-16">
                  <div v-if="formatFloatMult(formateNumber(dataInfo.qnhybl)) > 0" class="progress" :style="{width:`${formatFloatMult(formateNumber(dataInfo.qnhybl))}%`}"></div>
                  <div class="countInfo">{{dataInfo.hys}}</div>
                </div>
                <div class="itemSubTitle">会员数</div>
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="客户会员注册来源" name="source" class="m-b-16">
          <div class="collapseContent" style="padding: 24px 24px;border-radius: 2px;border: 1px solid #E4E7ED;margin-top: 19px">
            <div class="columnFlex">
              <div class="itemTitle m-b-8">客户内会员总数(人):</div>
              <div class="numberInfo">{{dataInfo.hys}}</div>
            </div>
            <div class="rowFlex jus-end">
              <div class="columnFlex">
                <div class="columnFlex m-b-10">
                  <div class="itemSubTitle m-b-10">线上来源(人):</div>
                  <div class="f36 c6f5 bold">{{getTransformData(dataInfo.xsly,'-')}}</div>
                </div>
                <div class="columnFlex">
                  <div class="itemSubTitle m-b-10">线下来源(人):</div>
                  <div class="f36 c18a bold">{{getTransformData(dataInfo.xxly,'-')}}</div>
                </div>
              </div>
              <div class="chartView m-l-30">
                <van-circle
                    v-model="dataInfo.realQnhybl"
                    :rate="100"
                    layer-color="#E4E7ED"
                    stroke-linecap="square"
                    :stroke-width="178"
                    :size="86"
                />
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="会员标签分布TOP5" name="labelTop" v-if="dataInfo.memLabelMap && dataInfo.memLabelMap.length > 0">
          <div class="collapseContent" style="padding: 0 0;border: none">
            <van-row style="border-bottom: 1px solid #D2D4DC">
              <van-col span="12">
                <div class="th">标签名称</div>
              </van-col>
              <van-col span="12">
                <div class="th">涉及会员数</div>
              </van-col>
            </van-row>
            <div class="width100" v-if="dataInfo.memLabelMap">
              <van-row v-for="(item,index) in dataInfo.memLabelMap" :key="index" :style="{borderBottom: index < dataInfo.memLabelMap.length - 1 ? '1px solid #D2D4DC' : 'none'}">
                <van-col span="12">
                  <div class="tr_title">{{item.name.length > 10 ? `${item.name.substring(0,10)}...` : item.name}}</div>
                </van-col>
                <van-col span="12">
                  <div class="tr_info">{{item.labelCount}}</div>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <div class="rowFlex alignitems jus-btw">
        <div class="sectionTitle">客户消费画像</div>
        <div class="rowFlex alignitems jus-end m-r-24">
          <div class="timeItem" v-if="filterItems && filterItems.time && filterItems.time.length > 0">
            {{filterItems.time[0].type == 'selectTime' ? customeTime : filterItems.time[0].value}}
          </div>
          <div class="rowFlex alignitems">
            <div v-if="!isNull(customeTime)" class="selectTimeView">{{customeTime}}</div>
            <img v-if="filterItems && Object.keys(filterItems).length > 0" src="@/assets/image/statisticManage/filtered@3x.png" class="imgView48" @click="handleFilter"/>
            <img v-else src="@/assets/image/statisticManage/filter@3x.png" class="imgView48" @click="handleFilter"/>
          </div>
        </div>
      </div>
      <van-collapse v-model="activeNames1" :border="false">
        <van-collapse-item title="会员客单价" name="price" class="m-b-16">
          <div class="collapseContent" style="box-shadow: none;border: none">
            <div class="rowFlex alignitems jus-btw">
              <div class="priceItem" v-for="(item,index) in priceItems" :key="index" :style="{width:`calc(calc(100% - ${(priceItems.length-1)*10}px)/${priceItems.length})`}">
                <div class="priceItemTitle">{{item.title}}</div>
                <div class="priceItemInfo">{{formateNumber(getTransformData(dataInfo[item.prop],'-'))}}{{getTransformData(item.unit,'')}}</div>
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="有过付费行为的占比" name="buyPercent" class="m-b-16">
          <div class="collapseContent" style="box-shadow: none;border: none">
            <div class="rowFlex alignitems jus-btw">
              <div class="priceItem" v-for="(item,index) in buyItems" :key="index" :style="{width:`calc(calc(100% - ${(buyItems.length-1)*10}px)/${buyItems.length})`}">
                <div class="priceItemTitle one-text">{{item.title}}</div>
                <div v-if="item.unit && item.unit == '%'" class="priceItemInfo">{{getTransformData(formatFloatMult(formateNumber(dataInfo[item.prop])),'-')}}{{getTransformData(item.unit,'')}}</div>
                <div v-else class="priceItemInfo">{{formateNumber(getTransformData(dataInfo[item.prop],'-'))}}{{getTransformData(item.unit,'')}}</div>
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="购买品类TOP5" name="buyTop" class="m-b-26">
          <div class="collapseContent">
            <div v-if="dataInfo.buyTop && dataInfo.buyTop.length > 0" id="chartView"></div>
            <van-empty
                v-else
                image-size="0px"
                description="暂无数据"
            />
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-pull-refresh>
    <filterDawer
      :show="showFilter"
      :corpId="corpId"
      :timeFilterItemList="timeFilterItemList"
      :collapseItemList="collapseItemList"
      :activeNames="filterActiveNames"
      :isBottom="false"
      @close="handleClose"
      @confirm="handleConfirm"
    ></filterDawer>
  </div>
</template>

<script>
import utils from "@/utils/common";
import filterDawer from "../../components/filterDawer.vue";
import * as echarts from "echarts";
import http from "@/utils/axios";
import moment from "moment";
export default ({
  components:{
    filterDawer
  },
  props:{
    memberId:{
      type:String,
      default:() => {
        return ''
      }
    },
    corpId:{
      type:String,
      default:() => {
        return ''
      }
    }
  },
  data() {
    return {
      dataInfo: {},
      refreshing:false,
      showFilter:false,
      queryData: {
        timeType:0
      },
      filterItemIds:{},
      filterItems:{},
      customeTime:utils.getTime('month', 3),
      activeNames:['percent','source','labelTop'],
      activeNames1:['price','buyPercent','buyTop'],
      timeFilterItemList:[],
      filterActiveNames: [],
      collapseItemList: [],
      priceItems:[
        {
          title:'客单价(元)',
          prop:'kdj'
        },
        {
          title:'消费人数(人)',
          prop:'xfrs'
        }
      ],
      buyItems:[
        {
          title:'客户总数(人)',
          prop:'hys'
          // prop:'hyzs'
        },
        {
          title:'会员数(人)',
          prop:'ffhys'
        },
        {
          title:'会员比例',
          prop:'ffyhblNew',
          // prop:'ffyhbl',
          unit:'%'
        }
      ],
      chart:null
    }
  },
  created() {
    this.$loading.hide();
    this.timeFilterItemList = [
      {
        title: '时间',
        key: 'timeType',
        isMultiple:false,
        list:[
          {
            id: '1',
            title: '一个月内',
            type: 'monthTime',
            value: utils.getTime('month', 1)
          },
          {
            id: '0',
            title: '三个月内(默认)',
            type: 'monthTime',
            default: true,
            value: utils.getTime('month', 3)
          },
          {
            id: '2',
            title: '半年内',
            type: 'monthTime',
            value: utils.getTime('month', 6)
          },
          {
            id: '3',
            title: '一年内',
            type: 'monthTime',
            value: utils.getTime('month', 12)
          }
        ]
      }
    ]
  },
  mounted() {
    this.getDetailInfo()
  },
  methods:{
    isNull(data){
      return utils.isNullData(data)
    },
    onRefresh(){
      this.dataInfo = {}
      this.getDetailInfo()
    },
    formateNumber(data){
      if(!utils.isNullData(data)){
        // data = data.toString()
        // if(data.indexOf('.') > -1){
        //   return Number(data).toFixed(2)
        // }
        return utils.formatFloat(Number(data), 2)
      }
      return ''
    },
    // 解决小数乘100，精度丢失问题
    formatFloatMult(data){
      if(!utils.isNullData(data)){
        return utils.formatFloatMult(Number(data)*100, 2)
      }
      return ''
    },
    /**
     * 查询基本信息
     * */
    getDetailInfo(){
      http({
        url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserVip?userId=${this.memberId}`,
        method: "get",
        parmes: {}
      }).then(rps => {
        this.refreshing = false
        if (rps.code == 200) {
          let data = rps.data;
          // data.realQnhybl = Number(data.qnhybl * 100)
          data.realQnhybl = Number(Number(data.xsly)/Number(data.hys)).toFixed(2)*100
          this.dataInfo = data
          this.getXFDetailInfo()
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 成员画像-消费画像
     */
    getXFDetailInfo(){
      http({
        url: `order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserBuy?userId=${this.memberId}&timeType=${this.queryData.timeType}`,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.dataInfo = Object.assign({}, this.dataInfo, data)
          // !isNull(cyhx.hys) ? `${formatFloatMult(Number(Number(xfhx.ffhys)/Number(cyhx.hys)),2)}%
          this.dataInfo.ffyhblNew = !utils.isNullData(this.dataInfo.hys) && this.dataInfo.hys != 0  ? Number(Number(this.dataInfo.ffhys)/Number(this.dataInfo.hys)) : ''
          if(this.dataInfo.buyTop && this.dataInfo.buyTop.length > 0){
            let buyTop = [].concat(this.dataInfo.buyTop)
            buyTop.forEach((item) => {
              item.name = item['店铺分类']
              item.value = item['订单数']
            })
            this.initEcharts(buyTop);
          }
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    initEcharts(data){
      let chartOption = {
        color:['#83D0EF','#A285D2','#FFAB67','#F7C739','#EB7E65'],
        legend: {
          // 图例
          right: "0",
          top: "20%",
          orient: "vertical",
          itemWidth: 10, //图例颜色块的宽度和高度
          itemHeight: 10,
          icon:"circle", // 图例前的图标为圆点
        },
        series: [
          {
            type: "pie",
            width:'90%',
            radius:'50%',
            label: {
              show: true,
              // alignTo: 'edge',
              // margin: '10%',
              // bleedMargin: 5,
              // distanceToLabelLine:1,
              // formatter: "{d}%-{c}人" // b代表名称，c代表对应值，d代表百分比
              formatter: "{d}%\n({c}人)" // b代表名称，c代表对应值，d代表百分比
            },
            data: data
          }
        ]
      }
      this.$nextTick(() => {
        this.chart = echarts.init(document.getElementById("chartView"));
        this.chart.setOption(chartOption);
        //随着屏幕大小调节图表
        window.addEventListener("resize", () => {
          this.chart.resize();
        });
      })
    },
    /**
     * 格式化数据
     */
    getTransformData(data, defaultValue = '') {
      if (utils.isNullData(data)) {
        return defaultValue
      }
      return data;
    },
    // 点击筛选
    handleFilter() {
      this.showFilter = true
    },
    // 关闭筛选框
    handleClose() {
      this.showFilter = false
    },
    // 筛选确认
    handleConfirm(selectItemIds,selectItems,customeTime,customMasterIds) {
      this.showFilter = false
      // let queryData = Object.assign({},selectItemIds)
      let queryData = JSON.parse(JSON.stringify(selectItemIds))
      for(let key in queryData){
        let val = queryData[key]
        if(val instanceof Array){
          let index = val.indexOf('-1')
          if(index > -1){
            queryData[key].splice(index,1)
          }
        }else{
          if(val == '-1'){
            queryData[key] = ''
          }
        }
      }
      let data = queryData.masterIds
      if(data == 3){// 指定群主
        queryData.masterIds = customMasterIds
      }else if(data == 2){// 只看自己
        queryData.masterIds = [this.currentUserId]
      }else{// 全部
        queryData.masterIds = []
      }
      this.filterItemIds = selectItemIds
      this.filterItems = selectItems
      if(!utils.isNullData(customeTime)){
        this.customeTime = customeTime
        let startTime = moment(customeTime.split('-')[0]).format('YYYY-MM-DD')
        let endTime = moment(customeTime.split('-')[1]).format('YYYY-MM-DD')
        queryData.startTime = startTime
        queryData.endTime = endTime
      }else{
        if(selectItems.timeType && !utils.isNullData(selectItems.timeType.value)){
          this.customeTime = selectItems.timeType.value
          let startTime = moment(selectItems.timeType.value.split('-')[0]).format('YYYY-MM-DD')
          let endTime = moment(selectItems.timeType.value.split('-')[1]).format('YYYY-MM-DD')
          queryData.startTime = startTime
          queryData.endTime = endTime
        }
      }
      this.queryData = Object.assign({},this.queryData,queryData)
      this.getXFDetailInfo()
    },
  }
})
</script>
<style lang="less" scoped>
@import url("../../style/index.css");
.container {
  width: 100%;
  .sectionTitle{
    padding: 36px 24px 16px 24px;
    font-size: 32px;
    font-weight: 500;
    color: #30417A;
    line-height: 40px;
  }
  .timeItem{
    background: #FFFAE6;
    border-radius: 0px 18px 18px 18px;
    padding: 4px 12px;
    font-size: 22px;
    font-weight: 400;
    color: #F08E3C;
    line-height: 28px;
    display: flex;
    align-items: center;
    margin-right: 12px;
  }
  .collapseContent{
    padding: 12px 12px;
    //box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
    //border: 1px solid #D8DCE6;
    .itemTitle{
      font-size: 28px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 36px;
    }
    .numberInfo{
      color: #F08E3C;
      font-size: 36px;
      font-weight: 500;
      line-height: 36px;
    }
    .barView{
      width: calc(100% - 47px);
      padding: 32px 0 17px 0;
      border-left: 1px solid #E4E7ED;
      border-bottom: 1px solid #E4E7ED;
    }
    .itemSubTitle1{
      font-size: 24px;
      font-weight: 400;
      color: #62615F;
      margin-left: 24px;
    }
    .itemSubTitle{
      font-size: 24px;
      font-weight: 400;
      color: #8C94A0;
    }
    .countInfo{
      color: #F08E3C;
      font-size: 24px;
      font-weight: bold;
      line-height: 34px;
    }
    .progress{
      height: 40px;
      background: #5B8FF9;
      margin-right: 16px;
    }
    .chartView {
      width: 178px;
      height: 178px;
    }
    .th,.tr_title{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      font-size: 28px;
      font-weight: 500;
      color: #26282A;
      background: #F2F5FC;
    }
    .tr_info{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      font-size: 28px;
      font-weight: 500;
      color: #26282A;
    }
    .priceItem{
      padding: 20px 0;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: rgba(68, 102, 245, 0.06);
      .priceItemTitle{
        font-size: 28px;
        font-weight: 500;
        color: #26282A;
      }
      .priceItemInfo{
        font-size: 32px;
        font-weight: 500;
        color: #4466F5;
      }
    }
    #chartView{
      width: 100%;
      height: 340px;
    }
  }
  .selectTimeView{
    background: #FFFAE6;
    border-radius: 0px 18px 18px 18px;
    padding: 4px 12px;
    font-size: 22px;
    font-weight: 400;
    color: #F08E3C;
  }
  /deep/ .van-cell {
    //padding: 0 0 !important;

    &::after {
      border-bottom: none !important;
    }
  }

  /deep/ .van-collapse-item__content {
   padding: 12px 24px 24px 24px !important;
  }

  /deep/ .van-collapse-item--border {
    &::after {
      border-top: none !important;
    }
  }
  /deep/ .van-cell__title, .van-cell__value{
    font-size: 28px;
    font-weight: 500;
    color: #3B3A38;
  }
}
</style>
